<template>
  <lf-pill
    v-tooltip="scorecardResult.score_card_status?.name"
    scorecard
    size="sm"
    class="font-semibold uppercase"
    :color-index="resultColorIndex"
    data-cy="funder-scorecard-tag"
  >
    <div class="flex space-x-1 text-xs">
      <span data-cy="funder-scorecard-tag-name">
        {{ scorecardResult.score_card?.name || "-" }}
      </span>

      <span>&bull;</span>

      <span data-cy="funder-scorecard-tag-points">{{ pointsRender }}</span>
    </div>
  </lf-pill>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getColorId } from "@/helpers/scorecards";

import LfPill from "@/components/ui/text/LfPill.vue";

import type { IScorecardResult } from "@/models/scorecards";

const props = defineProps<{ scorecardResult: IScorecardResult }>();

const resultColorIndex = computed(() => {
  return getColorId(
    props.scorecardResult.score_card_status?.color ?? ""
  ) as string;
});

const pointsRender = computed(() => {
  const pointsValue = Math.round(props.scorecardResult.points ?? 0);
  const totalPointsValue = props.scorecardResult.score_card?.points ?? 0;
  return `${pointsValue}/${totalPointsValue}`;
});
</script>
